export default "__VITE_ASSET__BGI16DOq__"